module.exports = __webpack_public_path__ + "img/bmp.52fc9212.png";